export function isContentEmpty(html) {
  if (!html) return true
  const cleaned = html
    .replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, '')
    .replace(/\s+/g, '')
  return cleaned === ''
}

export function withNewTabLinks(html) {
  return html.replace(/<a\b([^>]*)>/gi, (_, attrs) => {
    const attrsWithoutTargetRel = attrs
      .replace(/\s*target="[^"]*"/gi, '')
      .replace(/\s*rel="[^"]*"/gi, '')
    return `<a${attrsWithoutTargetRel} target="_blank" rel="noopener noreferrer">`
  })
}
